(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-brands"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.featured-brands__row').forEach((row) => {
    const track = row.querySelector('[data-track]');
    const next = row.querySelector('[data-next]');
    if (!track || !next || !track.children.length) return;
    // With scroll-snap mandatory, smooth scrolls must target exact snap
    // positions or Chrome snaps back to where it started.
    next.addEventListener('click', () => {
      const origin = track.firstElementChild.offsetLeft;
      const max = track.scrollWidth - track.clientWidth;
      const targets = Array.from(track.children).map((card) =>
        Math.min(card.offsetLeft - origin, max)
      );
      const target = targets.find((t) => t > track.scrollLeft + 1);
      track.scrollTo({ left: target === undefined ? 0 : target, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.featured-collection__row').forEach((row) => {
    const track = row.querySelector('[data-track]');
    const next = row.querySelector('[data-next]');
    if (!track || !next || !track.children.length) return;
    // With scroll-snap mandatory, smooth scrolls must target exact snap
    // positions or Chrome snaps back to where it started.
    next.addEventListener('click', () => {
      const origin = track.firstElementChild.offsetLeft;
      const max = track.scrollWidth - track.clientWidth;
      const targets = Array.from(track.children).map((card) =>
        Math.min(card.offsetLeft - origin, max)
      );
      const desired = track.scrollLeft + track.clientWidth * 0.8;
      const ahead = targets.filter((t) => t > track.scrollLeft + 1);
      const withinPage = ahead.filter((t) => t <= desired);
      const target = withinPage.length ? withinPage[withinPage.length - 1] : ahead[0];
      track.scrollTo({ left: target === undefined ? 0 : target, behavior: 'smooth' });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.featured-collections').forEach((root) => {
    const track = root.querySelector('[data-track]');
    if (!track || !track.children.length) return;
    const cards = Array.from(track.children);
    const dots = Array.from(root.querySelectorAll('[data-dot]'));
    const next = root.querySelector('[data-next]');

    // With scroll-snap mandatory, smooth scrolls must target exact snap
    // positions or Chrome snaps back to where it started.
    const snapTargets = () => {
      const origin = cards[0].offsetLeft;
      const max = track.scrollWidth - track.clientWidth;
      return cards.map((card) => Math.min(card.offsetLeft - origin, max));
    };

    const advance = () => {
      const targets = snapTargets();
      const target = targets.find((t) => t > track.scrollLeft + 1);
      track.scrollTo({ left: target === undefined ? 0 : target, behavior: 'smooth' });
    };

    // Auto-rotate, pausing while hovered/touched and in hidden tabs
    const seconds = parseFloat(root.dataset.autorotate);
    let timer = null;
    const stopRotate = () => {
      if (timer) clearInterval(timer);
      timer = null;
    };
    const startRotate = () => {
      if (!seconds || matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      stopRotate();
      timer = setInterval(() => {
        if (!document.hidden) advance();
      }, seconds * 1000);
    };
    root.addEventListener('pointerenter', stopRotate);
    root.addEventListener('pointerleave', startRotate);
    root.addEventListener('touchstart', stopRotate, { passive: true });
    root.addEventListener('touchend', startRotate);
    startRotate();

    if (next) {
      next.addEventListener('click', () => {
        advance();
        startRotate();
      });
    }

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        track.scrollTo({ left: snapTargets()[i], behavior: 'smooth' });
        startRotate();
      });
    });

    if (dots.length) {
      let ticking = false;
      track.addEventListener('scroll', () => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => {
          ticking = false;
          const targets = snapTargets();
          let active = 0;
          targets.forEach((t, i) => {
            if (Math.abs(t - track.scrollLeft) < Math.abs(targets[active] - track.scrollLeft)) {
              active = i;
            }
          });
          dots.forEach((dot, i) => {
            if (i === active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const overlay = document.querySelector('[data-search-overlay]');
    if (!overlay) return;
    const input = overlay.querySelector('[data-search-input]');
    const results = overlay.querySelector('[data-search-results]');
    const defaultPanel = overlay.querySelector('[data-search-default]');
    const searchUrl = overlay.querySelector('form').action;
    let timer;
    let controller;

    // Mirrors snippets/search-rewrite.liquid: a plain ASCII keyword query
    // becomes field syntax so Shopify skips its semantic padding (see the
    // snippet for the rules). Keep the two implementations in sync.
    const rewriteQuery = (raw) => {
      const plain = raw.trim();
      if (!plain || !/^[A-Za-z0-9 ._~'\-,&\/!]+$/.test(plain)) return plain;
      const words = plain.split(/\s+/);
      if (words.some((word) => /^(AND|OR|NOT)$/i.test(word) || word.startsWith('-'))) return plain;
      return words.map((word) => `(title:${word}* OR vendor:${word}* OR tag:${word}*)`).join(' ');
    };

    overlay.querySelector('form').addEventListener('submit', (event) => {
      const q = input.value.trim();
      if (!q) return;
      event.preventDefault();
      location.assign(`${searchUrl}?q=${encodeURIComponent(rewriteQuery(q))}`);
    });

    document.querySelectorAll('[data-search-open]').forEach((opener) => {
      opener.addEventListener('click', (event) => {
        event.preventDefault();
        overlay.showModal();
        input.focus();
      });
    });

    overlay.querySelector('[data-search-close]').addEventListener('click', () => overlay.close());
    overlay.addEventListener('click', (event) => {
      if (event.target === overlay) overlay.close();
    });

    const fetchResults = async () => {
      const q = input.value.trim();
      if (q.length < 1) {
        results.innerHTML = '';
        defaultPanel.hidden = false;
        return;
      }
      if (controller) controller.abort();
      controller = new AbortController();
      try {
        const params = `q=${encodeURIComponent(rewriteQuery(q))}&type=product&section_id=predictive-search`;
        const response = await fetch(`${searchUrl}?${params}`, { signal: controller.signal });
        if (!response.ok) return;
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const fresh = doc.querySelector('[data-predictive-results]');
        results.innerHTML = fresh ? fresh.innerHTML : '';
        defaultPanel.hidden = results.innerHTML !== '';
      } catch (error) {
        if (error.name !== 'AbortError') {
          results.innerHTML = '';
          defaultPanel.hidden = false;
        }
      }
    };

    input.addEventListener('input', () => {
      clearTimeout(timer);
      timer = setTimeout(fetchResults, 250);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  const placeholder = document.querySelector('[data-recommendations]');
  if (placeholder) {
    fetch(placeholder.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = new DOMParser().parseFromString(text, 'text/html');
        const row = html.querySelector('.recommendations');
        if (!row) return;
        const gender = placeholder.dataset.gender;
        if (gender) {
          row.querySelectorAll('.recommendations__item').forEach((item) => {
            const handles = (item.dataset.collections || '').split(',');
            if (!handles.includes(gender)) item.remove();
          });
        }
        if (row.querySelector('.recommendations__item')) placeholder.replaceWith(row);
      })
      .catch(() => {});
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const updateCounter = (modal) => {
      const counter = modal.querySelector('[data-modal-counter]');
      if (!counter) return;
      const track = modal.querySelector('[data-modal-track]');
      const index = Math.round(track.scrollLeft / track.clientWidth);
      counter.textContent = `${index + 1} / ${track.children.length}`;
    };

    document.addEventListener('click', (event) => {
      const opener = event.target.closest('[data-media-index]');
      if (opener) {
        const modal = opener.closest('.product')?.querySelector('[data-product-modal]');
        if (!modal) return;
        modal.showModal();
        const track = modal.querySelector('[data-modal-track]');
        track.scrollTo({ left: track.clientWidth * Number(opener.dataset.mediaIndex), behavior: 'instant' });
        updateCounter(modal);
        return;
      }

      const modal = event.target.closest('[data-product-modal]');
      if (!modal || !modal.open) return;
      if (event.target.closest('[data-modal-close]')) {
        modal.close();
        return;
      }
      const nav = event.target.closest('[data-modal-prev], [data-modal-next]');
      if (nav) {
        const track = modal.querySelector('[data-modal-track]');
        const direction = nav.hasAttribute('data-modal-prev') ? -1 : 1;
        track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
        return;
      }
      if (!event.target.closest('img')) modal.close();
    });

    document.addEventListener(
      'scroll',
      (event) => {
        if (event.target instanceof Element && event.target.hasAttribute('data-modal-track')) {
          updateCounter(event.target.closest('[data-product-modal]'));
        }
      },
      { capture: true, passive: true }
    );

    document.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      const modal = document.querySelector('[data-product-modal][open]');
      if (!modal) return;
      const track = modal.querySelector('[data-modal-track]');
      const direction = event.key === 'ArrowLeft' ? -1 : 1;
      track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-style"]) return;
  try {
    
  (() => {
    const placeholder = document.querySelector('[data-related-style]');
    if (!placeholder) return;

    const productHandle = (href) => {
      try {
        return new URL(href, location.origin).pathname.split('/').pop();
      } catch (error) {
        return null;
      }
    };

    fetch(placeholder.dataset.url)
      .then((response) => (response.ok ? response.text() : Promise.reject(new Error(response.status))))
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const row = doc.querySelector('[data-style-results]');
        if (!row) {
          placeholder.remove();
          return;
        }
        // Drop the current product and anything already shown on the page
        // (e.g. the server-rendered "More from <brand>" row).
        const seen = new Set([placeholder.dataset.currentHandle]);
        document.querySelectorAll('.product-card__link').forEach((link) => {
          const handle = productHandle(link.getAttribute('href'));
          if (handle) seen.add(handle);
        });
        row.querySelectorAll('[data-handle]').forEach((item) => {
          if (seen.has(item.dataset.handle)) item.remove();
        });
        if (row.querySelector('[data-handle]')) {
          placeholder.replaceWith(row);
        } else {
          placeholder.remove();
        }
      })
      .catch(() => placeholder.remove());
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search"]) return;
  try {
    
  (async () => {
    const related = document.querySelector('[data-search-related]');
    if (!related) return;
    const grid = related.querySelector('[data-search-related-grid]');
    const more = related.querySelector('[data-search-related-more]');
    const shown = new Set(
      [...document.querySelectorAll('.search-page__main .search-page__grid a[href*="/products/"]')]
        .map((link) => link.getAttribute('href').split('?')[0])
    );
    const params = new URLSearchParams(location.search);
    params.set('q', related.dataset.relatedQ);
    params.delete('page');
    params.set('section_id', 'search-related');
    try {
      const response = await fetch(`${location.pathname}?${params}`);
      if (!response.ok) return;
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const fresh = doc.querySelector('[data-related-results]');
      if (!fresh) return;
      fresh.querySelectorAll('.product-card').forEach((card) => {
        const link = card.querySelector('a[href*="/products/"]');
        if (!link || shown.has(link.getAttribute('href').split('?')[0])) card.remove();
      });
      if (!fresh.querySelector('.product-card')) return;
      grid.replaceChildren(...fresh.children);
      more.hidden = fresh.dataset.more !== 'true';
      related.hidden = false;
    } catch (error) {
      /* related items are optional; the exact results are already on the page */
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
